export const formatDayWeek = (str:any) => {
  let partes = str.split('/').map(Number);
  let data = new Date( partes[2], partes[1] -1 , partes[0]);
  return data.toLocaleString('pt-br', { weekday: 'long',  month: 'long', day: 'numeric' });
}
